import { SafeAny } from '@/common/types';
import { ReportState } from '../state';

export { getCurrentStep, stepOptions } from './get-steps';

const getFlatObjectToQuery = (object: SafeAny) =>
  Object.keys(object)
    .map((key) => `${key}=${encodeURIComponent(object[key as keyof typeof object])}`)
    .join('&');

export const getReports = (state: ReportState) => {
  if (!state.reportData) return [];

  const { data, sets } = state.reportData;

  return { data, sets };
};

export const getFinalReportUrls = (state: ReportState) => {
  if (!state.finalReport.data || !Array.isArray(state.finalReport.data?.data)) {
    return [];
  }

  const { config, data } = state.finalReport.data;

  const configQuery = getFlatObjectToQuery(config);
  return data.map(({ url, ...query }: SafeAny) => ({
    url: `${url}?${getFlatObjectToQuery(query)}&${configQuery}`,
    i18nLabel: 'downloadReport'
  }));
};
